{
  "app.title": "Tickbird · 工单工作台",
  "app.description": "Tickbird 工单工作台",
  "language.switch": "切换语言",
  "fallback.http.badRequest": "请求参数有误",
  "fallback.http.unauthorized": "登录已过期，请重新登录",
  "fallback.http.forbidden": "没有访问该资源的权限",
  "fallback.http.notFound": "请求的资源不存在",
  "fallback.http.requestTimeout": "请求超时，请稍后重试",
  "fallback.http.networkError": "网络连接异常，请检查网络后重试",
  "fallback.http.internalServerError": "服务器开小差了，请稍后重试",
  "fallback.http.requestFailed": "请求失败（{status}）",
  "fallback.http.messageWithDetails": "{message}：{details}",
  "fallback.oauth.authenticationFailed": "身份验证失败，请重新登录后重试。"
}
